import { render, staticRenderFns } from "./PhotoLightbox.vue?vue&type=template&id=3357ebdd&scoped=true"
import script from "./PhotoLightbox.vue?vue&type=script&lang=js"
export * from "./PhotoLightbox.vue?vue&type=script&lang=js"
import style0 from "./PhotoLightbox.vue?vue&type=style&index=0&id=3357ebdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3357ebdd",
  null
  
)

export default component.exports